import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ajaxGet } from '../../ajax'

const Payments = ({league}) => {
  const [payments, setPayments] = useState([])
  const [loading, setLoading] = useState(false)
  const currencyName = league.currency == 'usd' ? '' : ` (${league.currency.toUpperCase()})`

  useEffect(() => {
    loadPayments()
  }, [])

  const loadPayments = () => {
    ajaxGet(`/admins/leagues/${league.id}/payments.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      setPayments(json.payments)
      setLoading(false)
    })
  }

  const paymentsList = () => {
    return payments.map((payment, i) => {
      return <tr key={i}>
        <td>{payment.name}</td>
        <td>{payment.time}</td>
        <td>{payment.receipt_number}</td>
        { payment.brand &&
          <td className='payment-details'>
            <div className={'brand-img' + ` ${payment.brand.toLowerCase()}-img`}></div>
            <span>****</span>
            <span>{payment.last4}</span>
          </td>
        }
        { payment.source && <td>{payment.source}</td> }
        <td>${parseFloat(payment.amount).toFixed(2)}</td>
        <td>
          <a className='payment-receipt' href={`/admins/leagues/${league.id}/payments/${payment.id}.pdf`} target='_blank'>
            <span>Download</span>
            <img className='receipt-download' src='/images/leagues/receipt.svg' />
          </a>
        </td>
      </tr>
    })
  }

  return <div className='league-payments-wrapper'>
    <div id='league-payments'>
      { loading && <div className='animated-spinner'></div> }
      <div className={'payments-table-wrap' + (loading ? ' isLoading' : '')}>
        { loading && <div className='animated-spinner'></div> }
        <table className='payments-table'>
          <thead>
            <tr>
              <th>Name | Team</th>
              <th>Time</th>
              <th>Receipt #</th>
              <th>Type</th>
              <th>{`Amount${currencyName}`}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {paymentsList()}
          </tbody>
        </table>
      </div>
    </div>
  </div>
}

Payments.propTypes = {
  league: PropTypes.object.isRequired,
}

export default Payments
